const Plotter = {
	getFormElement: () => document.querySelector('#plotter-form'),
	params: {

	},
	init: function () {
		// Break on on single product page or cart page
		const single = document.querySelector('.single-product');
		const cart = document.querySelector('.woocommerce-cart');

		// Single page functionality
		if (single) {
			// Add a base variation on load
			this.variations.addNew();

			// Init select2
			this.refresh();
		}
	
		// Cart functionality
		if(cart) {
			this.cart.init();
		}
	},
	refresh: function () {
		this.select2.init();
		this.events.init();
		//this.events.handles.checkAddToCartBtn();
		this.events.handles.updateStafflingChart();
		this.events.handles.updatePriceLabel();
		this.events.handles.updateAddNewButton();
		this.select2.events.refreshOptions();
	},
	cart: {
		refresh: function () {
			Plotter.cart.hasChanged();
			Plotter.cart.events.handles.checkCartButtons();
		},
		events: {
			handles: {
				checkCartButtons: function () {
					const totalQty = Plotter.cart.qty.getAll().reduce((acc, item) => acc + parseInt(item.value), 0);
					const addToCartBtn = document.querySelector('.wc-proceed-to-checkout .checkout-button');
					const updateCartBtn = document.querySelector('.shop_table.cart button[name="update_cart"]');

					const { min_qty } = Plotter.rebates.getRebates();
				
					if(totalQty != 0 && totalQty < min_qty) {
						addToCartBtn.classList.add('disabled');
						updateCartBtn.classList.add('disabled');
						return
					}
		
					addToCartBtn.classList.remove('disabled');
					updateCartBtn.classList.remove('disabled');
				},
				updateQtyHandle: function (e) {
					Plotter.cart.refresh();
				},
				removeColor: function (e) {
					const attributes = e.target.closest('.plotter-attributes');
					attributes.remove();
					Plotter.cart.refresh();
				}
			},
			init: function () {
				Plotter.cart.qty.getAll().forEach((input) => {
					input.removeEventListener('change', this.handles.updateQtyHandle)
					input.addEventListener('change', this.handles.updateQtyHandle);
				})

				const removeBtns = document.querySelectorAll('.cart-row.artikellista .product-remove .remove');
				
				removeBtns.forEach((btn) => {
					btn.removeEventListener('click', this.handles.removeColor)
					btn.addEventListener('click', this.handles.removeColor);
				})

				Plotter.cart.refresh();
			}
		},
		qty: {
			state: {

			},
			getAll: function () {
				return Array.from(document.querySelectorAll('.plotter-attributes .product-quantity input.qty'));
			}
		},
		init: function () {	
			this.qty.state = JSON.stringify(this.qty.getAll().map((input) => input.value));
			this.events.init();
		},
		hasChanged: function () {
			const current = JSON.stringify(this.qty.getAll().map((input) => input.value));
			const cartHtml = document.querySelector('.cart-row.artikellista');

			// Clear previous messages
			document.querySelectorAll('.plotter-notice').forEach((notice) => notice.remove());

			//console.log(this.qty.state, current)

			if(this.qty.state !== current) {
				// Create element
				const notificationsHtml = document.createElement('div');
				notificationsHtml.classList.add('plotter-notice');
				notificationsHtml.innerHTML = hs.wc.plotter_product.lang.cart_changes_made

				//console.log(cartHtml)

				// Append to cart
				cartHtml.insertAdjacentElement('beforebegin', notificationsHtml);
			}
		}
	},
	rebates: {
		getRebates: function () {
			return JSON.parse(hs.wc?.plotter_product?.rebates);
		},
		calculateRebate: function (qty) {
			const { stafflings } = this.getRebates();

			if (!stafflings) {
				return false;
			}

			const rebateIndex = stafflings.findIndex((item) => {
				return qty >= item.min_qty && qty <= item.max_qty
			});

			return rebateIndex !== -1 ? {
				index: rebateIndex,
				...stafflings[rebateIndex],
			} : false;
		}
	},
	events: {
		handles:  {
			updatePriceLabel: function () {
				const priceLeft = document.querySelector('.totals-left')
				const priceLabel = document.querySelector('.totals-left .totals .total');
				const rightCartBtn = document.querySelector('.totals-right .add-to-cart');
				
				const count =  Plotter.variations.getTotalQty();
				const price = Plotter.variations.getTotalPrice();
				const { min_qty } = Plotter.rebates.getRebates();
				
				if(!priceLabel) {
					return;
				}

				if(count < min_qty) {
					priceLabel.style.display = 'none';
					priceLeft.style.visibility = 'hidden';
					rightCartBtn.disabled = true;
					return
				}

				priceLabel.style.display = 'block';
				priceLeft.style.visibility = 'visible';
				rightCartBtn.disabled = false;
				priceLabel.innerHTML = `${Number(price.toFixed(3))} ${hs.wc.currency}`;
			},
			updateStafflingChart: function () {
				const totalQty = Plotter.variations.getTotalQty();
				const {index: StafflingIndex, ...stafflings} = Plotter.rebates.calculateRebate(totalQty);
				const rebatesRows = document.querySelectorAll('.rebate-table .rebate-row');

				// Remove active class
				Array.from(rebatesRows).forEach((row) => row.classList.remove('active'));
				
				if (typeof StafflingIndex === 'undefined') {
					return;
				}

				const activeRow = Array.from(rebatesRows).forEach((row, index) => {
					if(index === StafflingIndex) {
						row.classList.add('active');
					}
				})
			},
			updateAddNewButton: function() {
				const plotterColors = Plotter.json.getPlotterColors();
				const addNewBtn = document.querySelector('.product-type-plotter .add-new-variation');

				console.log('plotterColors (DISABLED)', plotterColors.map(item => ({
						disabled: item.disabled,
						name: item.color_name
					})))

				if(plotterColors.every(item => item.disabled)) {
					addNewBtn.setAttribute('disabled', 'disabled');
				} else {
					addNewBtn.removeAttribute('disabled');
				}
			},
			checkAddToCartBtn: () => {
				const totalQty = Plotter.variations.getTotalQty();
				const addToCartBtn = document.querySelector('.add-to-cart');
				const { min_qty } = Plotter.rebates.getRebates();

				if(totalQty <= 0 || totalQty < min_qty) {
					addToCartBtn.setAttribute('disabled', 'disabled');
					return
				}

				addToCartBtn.removeAttribute('disabled');
			},
			addToCartHandle: (e) => {
				e.preventDefault();

				const variations = Plotter.variations.getFormData();
		
				jQuery(".loader-area").show();

				// Ajax add to cart using fetch
				fetch(hs.ajax_url, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
					},
					body: new URLSearchParams({
						action: 'hs_plotter_to_cart',
						product_id: hs.post_id,
						variations: JSON.stringify(variations)
					})
				}).then((response) => {
					return response.json();
				}).then((response) => {
					$('.woocommerce-notices-wrapper').remove();

					const { fragments: fragments } = response;

					if(fragments) {
						$('.content-main .content-white-inner').prepend(fragments?.notices_html);
					}
				}).catch((error) => {
					console.log(error)
				}).finally(() => {
					jQuery(".loader-area").hide();
				})
			},
			addNewHandle: (e) => {
				e.preventDefault();

				Plotter.variations.addNew(true);
				Plotter.refresh();
			},
			deleteVariationHandle: (e) => {
				e.preventDefault();

				const variation = e.target.closest('.variation');
				variation.remove();
				Plotter.refresh();
			},
			changeQtyHandle: (e) => {
				e.preventDefault();
				// const variation = e.target.closest('.variation');
				// const qty = e.target.value;

				const handle = Plotter.events.handles;

				//handle.checkAddToCartBtn();
				handle.updateStafflingChart();
				handle.updatePriceLabel();
			}
		},
		init: function () {	
			const plotterForm = Plotter.getFormElement();

			if (!plotterForm)
				return;

			const addNewBtn = plotterForm.querySelector('.add-new-variation');
			const deleteVariationBtns = plotterForm.querySelectorAll('.quantity .remove');
			const qtyInputs = plotterForm.querySelectorAll('.variations .quantity input.qty');
			const addToCartBtn = plotterForm.querySelector('.add-to-cart');
			
			if(addNewBtn) {
				addNewBtn.removeEventListener('click', this.handles.addNewHandle)
				addNewBtn.addEventListener('click', this.handles.addNewHandle);
			}

			if(addToCartBtn) {
				addToCartBtn.removeEventListener('click', this.handles.addToCartHandle)
				addToCartBtn.addEventListener('click', this.handles.addToCartHandle);
			}

			deleteVariationBtns?.forEach((btn) => {
				btn.removeEventListener('click', this.handles.deleteVariationHandle, true)
				btn.addEventListener('click', this.handles.deleteVariationHandle, true);
			});

			qtyInputs?.forEach((input) => {
				input.removeEventListener('change', this.handles.changeQtyHandle)
				input.addEventListener('change', this.handles.changeQtyHandle);
			})
		}
	},							
	variations: {
		getAll: function () {
			const select2 = this.getAllSelect2();

			const variations = Array.from(this.getFormData()).map((variation) => {
				const select2Item = select2.find((item) => item.value === variation.variation_id);
				
				return {
					...variation,
					...select2Item.metadata
				}
			})

			return variations;
		},
		getFormData: function() {
			const form = Plotter.getFormElement();
			const data = $(form).serializeArray();

			console.log('formData', data);

			const variation_ids = data.filter((item) => item.name === 'variation' && item.value != '*').map((item) => item.value);
			const quantities = data.filter((item) => item.name === 'quantity').map((item) => item.value);

			const variations = variation_ids.map((variation_id, index) => {
				return {
					variation_id,
					quantity: quantities[index]
				}
			});

			return variations;
		},
		getAllSelect2: function() {
			const select2Handles = document.querySelectorAll(".variations .color .color-select.select2");
			const selectedValues = [];

			select2Handles.forEach(select => {
				const selectValue = $(select).val();
				const selectMetadata = $(select).find(':selected').data('data');
				const selectedObject = {
					value: selectValue,
					metadata: selectMetadata
				};
				selectedValues.push(selectedObject);
			});

			return selectedValues;
		},
		addNew: function (removable = false) {
			const container = document.querySelector('.variations-wrapper .variations');
			const lang = hs.wc.plotter_product.lang;

			var template = `
				<div class="variation">
					<div class="color">
							<div class="inner">
									<select class="select color-select select2" name="variation">
										<option value="*">${lang.no_colors}</option>
									</select>
									<span class="stock"></span>
								</div>
						</div>

						<div class="qty-wrapper">
						<div class="quantity">
							<input type="number" step="1" min="0" max="" name="quantity" value="1" title="${lang.amount}" class="input-text qty text " size="4">
							${removable ? '<span class="remove">✖</span>' : ''}
							</div>
						</div>
				</div>
			`;

			container.insertAdjacentHTML('beforeend', template);
		},
		getTotalQty: function () {
			const variations = Array.from(document.querySelectorAll('.variations-wrapper .variations .variation input.qty'));
			return variations.reduce((acc, variation) => parseInt(acc) + parseInt(variation.value), 0)
		},
		getTotalPrice: function () {
			const variations = Plotter.variations.getAll();

			if(!variations) {
				return 0;
			}

			// const { rebate } = Plotter.rebates.calculateRebate(variations.length);
			// return rebate ? price - (price * rebate / 100) : price;

			return variations.reduce((acc, variation) => acc + parseFloat(variation?.price) * parseInt(variation?.quantity), 0);
		}
	},
	json: {
		getPlotterColors: function () {
			const store = document.querySelector('#plotter_colors_list');
			const variations = Plotter.variations.getAll();

			const existingColors = variations ? variations.map((variation) => {
				return parseInt(variation.id)
			}) : []

			const plotterColors = JSON.parse(atob(store.value)).map((item) => {
				return {
					...item,
					disabled: existingColors.includes(item.id) || (parseInt(item.stock_count) <= 0 && !item.allow_backorder) || !item.color_hex
				}
			});

			return plotterColors
		}
	},
	select2: {
		init: function () {
			const select2Handles = document.querySelectorAll(".variations .color .color-select.select2");
			const plotterColors = Plotter.json.getPlotterColors();
			
			if (!plotterColors)
				return;
	
			const handleSelectEvent = (e) => {        
				const {
					params: {
						data
					}
				} = e;

				const parentContainer = $(e.target).parent().closest('.inner');
				parentContainer.find('.stock').html(data.stock_html);
			}

			// Get nodelist from
			select2Handles.forEach(select => {
				// Check if select2 is already initialized
				if (select.classList.contains('select2-hidden-accessible')) {
					return
				}

				// If we have no selections, remove the variation
				if (plotterColors.every(item => item.disabled)) {
					const variation = select.closest('.variation');
					variation.remove();
				}

				// Clear before init
				$(select).empty();

				$(select).select2({
					data: plotterColors,
					templateResult: this.formatResultState,
					templateSelection: this.formatSelectionState,
					dropdownCssClass: "plotter-dropdown",
					containerCss: "plotter-container",
				}).on('select2:select', handleSelectEvent)
				.on('init.select2', function (e) {
					var firstItem = $(select).find('option:first');
					handleSelectEvent({
						params: {
							data: firstItem.data('data')
						},
						target: firstItem
					});
				}).on('select2:select', function (e) {
					Plotter.select2.events.refreshOptions();
				});

				$(select).trigger('init.select2');
			});
		},
		events: {
			refreshOptions: function () {		
				const variations = Plotter.variations.getAll();

				const existingColors = variations ? variations.map((variation) => {
					return parseInt(variation.id)
				}) : []

				const handles = document.querySelectorAll(".variations .color .color-select.select2");
							
				// Disable this option for other forms
				$(handles).each(function() {
					var select = $(this);

					// Enable all before disabling
					select.find('option').each(function() {
						var meta = $(this).data('data');
						meta.disabled = false;
					});

					select.find('option').each(function() {
						var meta = $(this).data('data');
						
						if(existingColors.includes(parseInt(meta.id))) {
							meta.disabled = true;
						}
					});
				});
			},
		},
		formatResultState(state) {
			if (!state.id) {
				return state.name;
			}

			var $state = $(
				`<span class="color-badge" style="background-color: #${state.color_hex}">&nbsp;</span> <span class="text">${state.color_name}</span>`
			);

			return $state;
		},
		formatSelectionState(state) {
			if (!state.id) {
				return state.name;
			}

			var $state = $(
				`<span class="color-badge" style="background-color: #${state.color_hex}">&nbsp;</span> <span class="text">${state.color_name}</span>`
			);

			return $state;
		}
	},
}

document.addEventListener('DOMContentLoaded', function () {
	Plotter.init();
});
